<template>
    <div class="page">
        <div class="page-hedaer line-bar-bottom">
            <el-breadcrumb separator="/"><el-breadcrumb-item>设备管理</el-breadcrumb-item></el-breadcrumb>
        </div>

        <div class="page-body list-page">
            <div class="filters">
                <el-form :inline="true">
                    <el-form-item label="设备类型：">
                        <el-select v-model="listConfig.device_type" placeholder="请选择" @change="handleSearch">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in typeData" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="绑定状态：">
                        <el-select v-model="listConfig.bind_state" placeholder="请选择" @change="handleSearch">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in bindData" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="信号状态：">
                        <el-select v-model="listConfig.signal_state" placeholder="请选择" @change="handleSearch">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in signalData" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="电量状态：" class="last-item">
                        <el-select v-model="listConfig.power_level" placeholder="请选择" @change="handleSearch">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in electricData" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item class="form-item-search">
                        <el-input
                            v-model="listConfig.input"
                            clearable
                            placeholder="请输入设备编号"
                            @keyup.enter.native="handleSearch"
                        >
                          <div slot="append" class="btn-search" @click.stop="handleSearch"><i class="el-icon-search"></i></div>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>

            <div class="operation">
                <el-button type="primary" @click="$router.push('/device/add')">新增设备</el-button>
                <el-button @click="handleToImport">批量导入</el-button>
            </div>

            <div class="list" v-loading="loading">
                <el-table :data="listData">
                    <el-table-column prop="device_type" label="设备类型">
                        <template slot-scope="scope">
                            {{ scope.row.device_type | FDeviceType }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="device_imei" label="设备编号" width="190px"></el-table-column>
                    <el-table-column prop="bind_state" label="绑定状态">
                        <template slot-scope="scope">
                            <div class="bind-link" :class="{ 'link active': scope.row.bind_state === 1 }" @click="scope.row.user_id && $router.push('/household/detail/' + scope.row.user_id)">{{ scope.row.bind_state | FDeviceBind }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="signal_state" label="信号状态">
                        <template slot-scope="scope">
                            <div class="status" :class="{ green: scope.row.signal_state === 1 }">{{ scope.row.signal_state | FDeviceSignal }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="power_value" label="电量">
                        <template slot-scope="scope">
                          <div v-if="scope.row.power_value">{{ scope.row.power_value | FNull }}%</div>
                          <div v-else>--</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="power_level" label="电量状态">
                        <template slot-scope="scope">
                            <div v-if="scope.row.power_level" class="status" :class="scope.row.power_level > 1 ? 'blue' : 'red'">{{ scope.row.power_level | FDeviceElectric }}</div>
                            <div v-else>--</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="115">
                        <template slot-scope="scope">
                            <a href="javascript: void(0);" class="link active" @click="handleRemove(scope.row)">删除</a>
                        </template>
                    </el-table-column>

                    <template slot="empty">
                        <div class="list-null">
                            <img src="../../assets/icons/icon_blank.png" alt="暂无数据" />
                            <p><em>暂无数据</em></p>
                            <p>建议您修改搜索条件后重新再试</p>
                        </div>
                    </template>
                </el-table>

                <div class="paginations">
                    <el-pagination
                        :current-page="listConfig.currPage"
                        @size-change="handleSizeChange"
                        :page-size="listConfig.pageSize"
                        :page-sizes="[10, 50, 100]"
                        :total="listTotal"
                        @current-change="handleCurrentChange"
                        layout="prev, pager, next, sizes, jumper"
                    ></el-pagination>
                </div>
            </div>
        </div>

        <dialogImport ref="dialogImport" />
    </div>
</template>

<script>
import { ApiDeviceList, ApiDeviceDelete } from '@/api/device';
import dialogImport from './components/dialogImport';


export default {
  name: 'devicePage',
  components: {
    dialogImport,
  },
  data() {
    return {
      loading: false,

      // 表格数据
      listData: [],
      listTotal: 0,

      // 列表请求参数
      listConfig: {
        sysUserId: this.$store.getters.userId,
        isAdmin: this.$store.getters.isAdmin,
        device_type: '',
        bind_state: '',
        signal_state: this.$route.query.signal_state ? Number(this.$route.query.signal_state) : '',
        power_level: this.$route.query.electric ? Number(this.$route.query.electric) : '',
        input: '',
        currPage: 1,
        pageSize: 10,
      },

      // 筛选项
      typeData: [
        {
          value: 0,
          label: '门磁',
        },
        {
          value: 1,
          label: '迷你报警器',
        },
      ],
      bindData: [
        {
          value: 0,
          label: '未绑定',
        },
        {
          value: 1,
          label: '已绑定',
        },
      ],
      signalData: [
        {
          value: 0,
          label: '离线',
        },
        {
          value: 1,
          label: '在线',
        },
      ],
      electricData: [
        {
          value: 1,
          label: '低电量',
        },
        {
          value: 2,
          label: '正常',
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.handleGetList();
  },
  methods: {
    // 当前页面
    handleCurrentChange(page) {
      this.listConfig.currPage = page;

      this.handleGetList();
    },

    // 每页显示数量
    handleSizeChange(size) {
      this.listConfig.pageSize = size;
      this.listConfig.currPage = 1;

      this.handleGetList();
    },

    // 搜索
    handleSearch() {
      this.listConfig.currPage = 1;

      this.handleGetList();
    },

    // 调用列表Api
    handleGetList() {
      if (this.loading) {
        return false;
      }

      this.loading = true;

      ApiDeviceList(this.listConfig)
        .then((res) => {
          this.loading = false;

          this.listData = res.data.list;
          this.listTotal = res.data.total;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 删除设备
    handleRemove(row) {
      const tmpType = row.device_type === 0 ? '门磁' : '迷你报警器';
      let tmpMsg = '确定从系统中删除 ' + tmpType + row.device_imei + ' 吗？';

      // 已绑定
      if (row.bind_state === 1 && row.household_name) {
        tmpMsg += '该设备已绑定住户 ' + row.household_name + row.household_phone;
      }

      this.$confirm(
        '<div class="custom-message-title">删除确认</div><div class="custom-message-content">' + tmpMsg + '</div>',
        {
          customClass: 'custom-message',
          dangerouslyUseHTMLString: true,
          // showClose: false,
          type: 'warning',
        },
      )
        .then(() => {
          ApiDeviceDelete(row.gm_id)
            .then(() => {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });

              this.handleGetList();
            })
            .catch(() => {});
        })
        .catch(() => {});
    },

    // 导入
    handleToImport() {
      this.$refs.dialogImport.handleOpen();
    },
  },
};
</script>

<style lang="scss" scoped>
.bind-link {
  cursor: text;

  &.active {
    cursor: pointer;
  }
}
</style>
